export default {
  type: "object",
  properties: {
    min: {
      type: "integer",
      description: "minimal measure value",
      example: "60"
    },
    max: {
      type: "integer",
      description: "maximal measure value",
      example: "220"
    }
  }
};
